.tooltip-form-field-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: start;

  gz-tooltip {
    margin-left: var(--spacer);

    .icon {
      font-size: 24px;
      line-height: 0.8;
      color: var(--chart-300-icon-buttons);
    }
  }
}

.text-form-field-section {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: start;
}

.subtitle {
  font-size: var(--body-size);
  line-height: 21px;
}
